import {
  CloseIcon,
  lightColorPalette,
  NewIcon,
  SidebarMenuEarlyAccessBetaBadge
} from '@linearb/linui-common';
import { Body1 } from '@linearb/linui-common/typography';
import useCloseIterationSummary from './useCloseIterationSummary';
import { Box, Stack } from '@mui/material';
import ShareMenu from './ShareMenu';
import { ITERATION_SUMMARY_TITLE } from './IterationSummary.consts';
import { formatIterationRange } from 'state/selectors/iterations-picker';
import { LBButton } from '@linearb/buzz';

const Header = ({ data, isShareable = true, trackingEventsHandler }) => {
  const { onCloseIterationSummary } = useCloseIterationSummary();

  const iterationName = data?.iteration_name;
  const iterationRange = formatIterationRange({
    start_date: data?.iteration_start_date,
    end_date: data?.iteration_end_date
  });

  return (
    <div className='flex flex-row items-center justify-between'>
      <Stack flexDirection='row' gap={1} alignItems='flex-start'>
        <Box position='relative' top={3}>
          <NewIcon color={lightColorPalette.lbNotificationBlue} />
        </Box>
        <Body1>
          {ITERATION_SUMMARY_TITLE}&nbsp;
          <Box fontWeight='bold' display='inline-block'>
            {iterationName}&nbsp;
            <Box display='inline-block'>({iterationRange})</Box>
            &nbsp;
            <Box
              display='inline-block'
              lineHeight='100%'
              position='relative'
              top={1}
              marginLeft={0.2}
            >
              <SidebarMenuEarlyAccessBetaBadge
                color={lightColorPalette.lbSbBlue_60}
                text='Beta'
              />
            </Box>
          </Box>
        </Body1>
      </Stack>
      <Stack flexDirection='row' gap={1} alignItems='center'>
        {isShareable && (
          <ShareMenu
            data={data}
            iterationRange={iterationRange}
            trackingEventsHandler={trackingEventsHandler}
          />
        )}
        <LBButton variant='link' onClick={onCloseIterationSummary}>
          <CloseIcon />
        </LBButton>
      </Stack>
    </div>
  );
};

export default Header;
